<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.bateria.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
            <v-col cols="12">
                
                <v-container>
                    
                    <!--
                    <v-form v-model="valid" lazy-validation>
                    <v-row>
                        <v-col v-for="(value, key) in datos" :key="key" cols="12" sm="3">
                        <v-text-field
                            density="compact"  
                            variant="outlined" 
                            :label="formatLabel(key)"
                            v-model.number="datos[key]"
                            :type="getFieldType(key)"                            
                            :hint="getHint(key)"
                            @input="updateValue" 
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    </v-form>
                    -->


                    <v-row>
                     <!-- <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('pmax')"
                            v-model.number="datos['pmax']"
                            type="number"                            
                            :hint="getHint('pmax')"
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>-->
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capac')"
                            v-model.number="datos['capac']"
                            type="number"                            
                            :hint="getHint('capac')"
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('rend')"
                            v-model.number="datos['rend']"
                            type="number"                            
                            :hint="getHint('rend')"
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('emin')"
                            v-model.number="datos['emin']"
                            type="number"                            
                            :hint="getHint('emin')"
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>


                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('emax')"
                            v-model.number="datos['emax']"
                            type="number"                            
                            :hint="getHint('emax')"
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>
         <!--             
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexf')"
                            v-model.number="datos['capexf']"
                            type="number"                            
                            :hint="getHint('capexf')"
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>

                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexv')"
                            v-model.number="datos['capexv']"
                            type="number"                            
                            :hint="getHint('capexv')"
                            @input="updateValue" 
                        ></v-text-field>

                      </v-col>

                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('opex')"
                            v-model.number="datos['opex']"
                            type="number"                            
                            :hint="getHint('opex')"
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                    -->

                    
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('degrad')"
                            v-model.number="datos['degrad']"
                            type="number"                            
                            :hint="getHint('degrad')"
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('vutil')"
                            v-model.number="datos['vutil']"
                            type="number"                            
                            :hint="getHint('vutil')"
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>

                      </v-col>


                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('reempu')"
                            v-model.number="datos['reempu']"
                            type="number"                            
                            :hint="getHint('reempu')"
                            @input="updateValue"
                            :rules="[rules.Negativo]" 
                        ></v-text-field>
                      </v-col>


                    </v-row>
                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-typography variant="h1">
                          {{ $t('simulacion.modulo.electrolizador.datos_economicos') }}
                        </v-typography>                                              
                      </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols="12" sm="6">
                      <v-switch
                        v-model="usarCurvasBOP"
                        :label="usarCurvasBOP ?  $t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_curvas') : $t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_especifico')"
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>
                    <v-row v-if="!usarCurvasBOP">
                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX
                        :titulo="$t('simulacion.modulo.bateria.capex')"
                        v-model:valorVariable="datos.capexv"
                        v-model:valorFijo="datos.capexf"
                        unidad-variable="kEUR/MWh"
                        unidad-fijo="kEUR"
                         />
                      </v-col>
º 

                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX 
                        :titulo="$t('simulacion.modulo.bateria.opex')"
                        v-model:valorVariable="datos.opexv"
                        v-model:valorFijo="datos.opexf"
                        unidad-variable="kEURh/MWh año"
                        unidad-fijo="kEUR año"

                        />
                      </v-col>
                     
                    </v-row>


                </v-container>

            </v-col>
            </v-row>
        </v-card-text>
    </v-card>



</template>

<script>
import ComponenteEditorCAPEXOPEX from '../components/ComponenteEditorCAPEXOPEX.vue';

export default {
  props: {
    modelValue: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    },
    usarCapexOpexGeneralBateria: String
  },
  components:{
    ComponenteEditorCAPEXOPEX,
  },
  data() {
    return {
      valid: false,
      datos: { ...this.modelValue }, // Inicializa los datos con el valor recibido
      labels: {
        pmax: this.$t('simulacion.modulo.bateria.pmax'),
        capac: this.$t('simulacion.modulo.bateria.capac'),
        rend: this.$t('simulacion.modulo.bateria.rend'),
        capexf: this.$t('simulacion.modulo.bateria.capexf'),
        capexv: this.$t('simulacion.modulo.bateria.capexv'),
        opex: this.$t('simulacion.modulo.bateria.opex'),
        degrad: this.$t('simulacion.modulo.bateria.degrad'),
        vutil: this.$t('simulacion.modulo.bateria.vutil'),
        reempu: this.$t('simulacion.modulo.bateria.reempu'),
        emin: this.$t('simulacion.modulo.bateria.emin'),
        emax: this.$t('simulacion.modulo.bateria.emax'),
      },
      campos_ocultos: ["ppvfija"],
      rules: {
        required: v => !!v || this.$t('mensajes.campo_requerido'),
        Negativo: (v) => {
        return v === null || v === undefined || v === '' || v >= 0
          ? true
          : 'El valor no puede ser negativo';
          }
      },
      usarCapexOpexGeneral: this.usarCapexOpexGeneralBateria || 'especifico'
    };
  },
  computed:{
    usarCurvasBOP: {
      get() {
        return this.datos.curvas?.capex === 1 && this.datos.curvas?.opex === 1;
      },
      set(val) {
        this.datos.curvas.capex = val ? 1 : 0;
        this.datos.curvas.opex = val ? 1 : 0;
      }
    }
  },
  watch: {
    // Vigila los cambios en `datos` y emite el evento cuando cambian
    datos: {
      handler(newDatos) {
        this.$emit('update:modelValue', newDatos);
      },
      deep: true, // Escucha los cambios profundos dentro de `datos`
    },


    '$i18n.locale'() {      
          
      this.labels.pmax = this.$t('simulacion.modulo.bateria.pmax')
      this.labels.capac = this.$t('simulacion.modulo.bateria.capac')
      this.labels.rend = this.$t('simulacion.modulo.bateria.rend')
      this.labels.capexf = this.$t('simulacion.modulo.bateria.capexf')
      this.labels.capexv = this.$t('simulacion.modulo.bateria.capexv')
      this.labels.opex = this.$t('simulacion.modulo.bateria.opex')
      this.labels.degrad = this.$t('simulacion.modulo.bateria.degrad')
      this.labels.vutil = this.$t('simulacion.modulo.bateria.vutil')
      this.labels.reempu = this.$t('simulacion.modulo.bateria.reempu')  
      this.labels.emin = this.$t('simulacion.modulo.bateria.emin')  
      this.labels.emax = this.$t('simulacion.modulo.bateria.emax')  
    },
    
  },
  mounted(){
    /*
    {"pmax":50,"capac":4,"rend":0.85,"capexf":0,"capexv":240000,"opex":0.02,"degrad":0.02,"vutil":15,"reempu":0.5,"emin":0,"emax":1}
    */
  },
  methods: {
    actualizarDatos(){

        this.datos={...this.modelValue 
      }

      },
    formatLabel(key) {
      let out = key.charAt(0).toUpperCase() + key.slice(1)
      out = this.labels[key]
      return out;
    },
    getFieldType(key) {
      if (key === 'capac' || key === 'capex' || key === 'nfijo') {
        return 'number';
      }
      return 'text';
    },
    getHint(key) {
      if (key === 'capex') {
        return 'In currency';
      }
      return '';
    },
    saveData() {
      console.log('Data saved:', this.datos);
    },
    emitirOpcionGeneral() {
      this.$emit('update:usarCapexOpexGeneralBateria', this.usarCapexOpexGeneral);
    }
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}
</style>
